<template>
<div class="md-layout">
    <div id="promo_track" class="mktops-promotions-track">
        <div class="mktops-maincontent-track md-layout md-gutter">
            <div class="mktops-mainheader-text md-layout-item">
                <label class="head-title-page">TRACK MY PROMOTION</label>
            </div>
            <div class="md-layout-item mktops-graph-layout">
                <md-card class="main-content">
                    <div class="main-content-header">
                        <div class="group-mktops-label">
                            <label class="mktops-subheader-text">Performance View</label>
                        </div>
                        <div class="group-mktops-label-btn text-align">
                            <div class="mktops-label-btn green" @click="toggleHeight('increase_sales')" :class="increase_sales ? 'mktops-label-btn green':'mktops-label-btn gray'">Increase Sales</div>
                            <div class="mktops-label-btn sky" @click="toggleHeight('increase_outlet')" :class="increase_outlet ? 'mktops-label-btn green':'mktops-label-btn gray'">Increase Outlet</div>
                            <div class="mktops-label-btn blue" @click="toggleHeight('new_product')" :class="new_product ? 'mktops-label-btn green':'mktops-label-btn gray'">New Product</div>
                            <div class="mktops-label-btn violet" @click="toggleHeight('compete')" :class="compete ? 'mktops-label-btn green':'mktops-label-btn gray'">Compete</div>
                            <div class="mktops-select-view">
                                <md-field class="box">
                                    <md-select v-model="graph_selected">
                                        <md-option class="latofont" value="Bubble Chart">Bubble Chart</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                    </div>
                    <chart :options="optionsChart"></chart>
                </md-card>
            </div>
            <div class="md-layout-item mktops-list-layout">
                <md-card class="main-content">
                    <div class="main-content-header">
                        <div class="group-mktops-label">
                            <label class="mktops-subheader-text">LIST OF PROMOTIONS SORTED BY</label>
                        </div>
                        <div class="group-mktops-label-btn">
                            <div class="mktops-search-text-align">
                                <div class="mktops-select-view">
                                    <md-field class="box dp-performance">
                                        <md-select v-model="performance">
                                            <md-option class="latofont" value="Best Performing">Best Performing</md-option>
                                        </md-select>
                                    </md-field>
                                </div>
                                <div class="mktops-select-view">
                                    <md-field class="md-search-box">
                                        <i class="md-icon material-icons">search</i>
                                        <md-input type="text" v-model="iptSearch" placeholder="Search my promotions…"></md-input>
                                    </md-field>
                                </div>
                            </div>
                            <div class="mktops-select-text-align">
                                <div class="mktops-select-view">
                                    <md-field class="box">
                                        <md-select class="status-type" v-model="slcStatus">
                                            <md-option class="latofont" v-for="(item,index) in status" :key="index" v-bind:value="item">{{item}}</md-option>
                                        </md-select>
                                    </md-field>
                                </div>
                                <div class="mktops-select-view">
                                    <md-button class="md-icon-button" @click="showFilterDialog = true">
                                        <md-icon title="Add Filters">filter_list</md-icon>
                                    </md-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout filter-chips" v-if="filterChips.length > 0">
                            <div v-for="(items, idx) in filterChips" :key="items.keyId">
                                <span class="tab-chip -primary" :title="items.name">
                                    {{ countString(items) }}
                                    <span class="tab-chip -delete" @click="deleteFilter(items, idx)">
                                        <i class="material-icons">close</i>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div id="table-track-list">
                            <div id="divHeadList">
                                <div style="width: 4%;"></div>
                                <div style="width: 6%;"></div>
                                <div style="width: 26%;">Promotion</div>
                                <div style="width: 10%;" class="-text-right">Avg Cost</div>
                                <div style="width: 10%;" class="-text-right">Gross Profit</div>
                                <div style="width: 10%;" class="-text-right">No. Outlets</div>
                                <div style="width: 10%;" class="-text-right">Incremental</div>
                                <div style="width: 10%;" class="-text-right">Past week</div>
                                <div style="width: 10%;" class="-text-right">Total</div>
                            </div>
                            <div id="divBodyList">
                                <div v-for="(item, rIndex) in tbTrackList" :key="rIndex">
                                    <div id="mainRows" :class="'row-bg-gray'">
                                        <div style="width: 4%;" class="-text-center view-log">
                                            <!-- <md-button v-if="(item.children)" class="md-raised button-viewlog">view log</md-button> -->
                                            <template v-if="(item.children)">
                                                <i v-if="(indexExpand == rIndex && checkExpand == true)" class="md-icon material-icons expand-row" @click="onExpand(rIndex)">expand_less</i>
                                                <i v-else class="md-icon material-icons expand-row" @click="onExpand(rIndex)">expand_more</i>
                                            </template>
                                        </div>
                                        <div style="width: 6%;"><div class="mktops-circle-green"></div></div>
                                        <div style="width: 26%;">
                                            <div style="display: -webkit-inline-box; color: rgba(0,0,0,.38);">{{ item.promo_code }}</div>
                                            <div>{{ item.promo_name }}</div>
                                        </div>
                                        <div style="width: 10%;" class="-text-right">$ {{ formatNumber(item.avgcost, 2) }}</div>
                                        <div style="width: 10%;" class="-text-right">{{ formatNumber(item.gross, 2) }}%</div>
                                        <div style="width: 10%;" class="-text-right">{{ item.outlets }}</div>
                                        <div style="width: 10%;" class="-text-right">$ {{ formatNumber(item.incremental, 2) }}</div>
                                        <div style="width: 10%;" class="-text-right">$ {{ formatNumber(item.pastweek, 2) }}</div>
                                        <div style="width: 10%;" class="-text-right">$ {{ formatNumber(item.total, 2) }}</div>
                                        <div style="width: 4%;" class="-text-right">
                                            <i class="md-icon material-icons expand-row">more_vert</i>
                                        </div>
                                    </div>
                                    <template v-if="(item.children)">
                                        <div class="childRows" :class="'row-bg-gray'" :id="`childRows_${rIndex}`" v-for="(logItem, logIndex) in item.children" :style="{ 'display': (indexExpand == rIndex && checkExpand == true) ? 'table' : 'none' }" :key="logIndex">
                                            <div style="width: 4%; margin-right: 2px;" class="-text-center view-log"></div>
                                            <div style="width: 6%;"><div class="mktops-circle-green"></div></div>
                                            <div style="width: 26%;">
                                                <div style="display: -webkit-inline-box; color: rgba(0,0,0,.38);">{{ logItem.promo_code }}</div>
                                                <div>{{ logItem.promo_name }}</div>
                                            </div>
                                            <div style="width: 10%;" class="-text-right">$ {{ formatNumber(logItem.avgcost, 2) }}</div>
                                            <div style="width: 10%;" class="-text-right">{{ formatNumber(logItem.gross, 2) }}%</div>
                                            <div style="width: 10%;" class="-text-right">{{ logItem.outlets }}</div>
                                            <div style="width: 10%;" class="-text-right">$ {{ formatNumber(logItem.incremental, 2) }}</div>
                                            <div style="width: 10%;" class="-text-right">$ {{ formatNumber(logItem.pastweek, 2) }}</div>
                                            <div style="width: 10%;" class="-text-right">$ {{ formatNumber(logItem.total, 2) }}</div>
                                            <div style="width: 4%;" class="-text-right"></div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </md-card>
            </div>
        </div>

        <md-dialog :md-active.sync="showFilterDialog" class="filter-dialog" :md-click-outside-to-close="false">
            <md-dialog-title>Add Filters</md-dialog-title>
            <div class="layout-dialog">
                <multiselect v-model="filterProductGroup" label="label" track-by="id" :placeholder="placeholderPro" :options="productGroups" :searchable="true" :max-height="80" :show-no-results="false" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" :custom-label="customLabel">
                    <template slot="singleLabel" slot-scope="{ option }">
                        <div>
                            <div class="-label">{{ option.id }} - {{ option.label }}</div>
                            <div class="-delete" @mousedown.prevent.stop="clearAll(option.id, 'product')">
                                <i class="material-icons">close</i>
                            </div>
                        </div>
                    </template>
                </multiselect>
                <multiselect v-model="filterCustGroup" label="group_name" track-by="group_name" :placeholder="placeholderCust" :options="customerGroups" :open-direction="'top'" :searchable="true" :max-height="80" :show-no-results="false" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" style="margin-top:22px">
                    <template slot="singleLabel" slot-scope="{ option }">
                        <div>
                            <div class="-label">{{ option.group_name }}</div>
                            <div class="-delete" @mousedown.prevent.stop="clearAll(option.id, 'customer')">
                                <i class="material-icons">close</i>
                            </div>
                        </div>
                    </template>
                </multiselect>
            </div>

            <md-dialog-actions class="-action">
                <md-button @click="closeFilterDialog" class="md-cancel">cancel</md-button>
                <md-button class="md-primary" @click="addCondFilter">add filter</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</div>
</template>

<script>
import Chart from "vue-echarts/components/ECharts";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/scatter";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import Multiselect from "vue-multiselect";
export default {
    name: "promotion-track",
    components: {
        Chart,
        Multiselect
    },
    created() {
        this.$store.dispatch("pmtrack/getCustomerGroups");
        this.$store.dispatch("pmtrack/getProductGroups");
        this.$store.dispatch("pmtrack/getChartBubble");
    },
    data: () => ({
        increase_sales: true,
        increase_outlet: true,
        new_product: true,
        compete: false,
        indexExpand: '',
        checkExpand: false,
        oldExpand: '',
        graph_selected: "Bubble Chart",
        status: ["All", "Draft", "Pending", "Return", "Active"],
        slcStatus: "All",
        performance: "Best Performing",
        showFilterDialog: false,
        filterChips: [],
        filterProductGroup: [],
        filterCustGroup: [],
        iptSearch: "",
        placeholderPro: "Filter by Product or Product Group",
        placeholderCust: "Filter by Customer Group"
    }),
    watch: {
        iptSearch: function () {
            this.searchPromotion();
        },
        slcStatus: function () {
            this.searchPromotion();
        },
        showFilterDialog: function () {
            this.$store.commit("pmmanage/closeApvDialog");
        },
        filterChips: function () {
            if (this.filterChips.length == 0) {
                this.filterProduct = [];
                this.filterCustGroup = [];
            }
        },
        filterProduct: function () {
            this.placeholderPro =
                this.filterProduct.length > 0 ?
                "" :
                "Filter by Product or Product Group";
        }
    },
    computed: {
        productGroups() {
            return this.$store.getters["pmtrack/product_groups"];
        },
        customerGroups() {
            return this.$store.getters["pmtrack/customer_groups"];
        },
        tbTrackList() {
            return this.$store.getters["pmtrack/table_list"];
        },
        optionsChart() {
            return this.$store.getters["pmtrack/options_chart"];
        }
    },
    methods: {
        formatNumber(value, dicimal) {
            if (isNaN(parseFloat(value))) {
                return value;
            } else {
                if (value % 1 == 0) {
                    // return true = int
                    return parseFloat(value).toLocaleString(undefined, {
                        minimumFractionDigits: dicimal,
                        maximumFractionDigits: dicimal
                    });
                } else {
                    let parts = value.toString().split(".");
                    let num = (parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                    let digit = parts[1].slice(0, 2);
                    return num + "." + digit;
                    // return parts.join(".");
                }
            }
        },
        toggleHeight: function (condition) {
            let checkTypeOnClick;
            let key;
            let index;
            let tmp;
            let data;

            switch(condition) {
              case 'increase_sales':
                this.increase_sales = !this.increase_sales;
                checkTypeOnClick = 0;
                key = 'IS';

                index = checkTypeOnClick;
                tmp = this.$store.getters["pmtrack/tmp_series"];
                data = tmp[key];
                switch(this.increase_sales) {
                case true:
                    this.$store.commit("pmtrack/setValueSeries", {index, data});    
                    break;
                case false:
                    data = [];
                    this.$store.commit("pmtrack/setValueSeries", {index, data});
                }
                break;

              case 'increase_outlet':
                this.increase_outlet = !this.increase_outlet;
                checkTypeOnClick = 1;
                key = 'IO';

                index = checkTypeOnClick;
                tmp = this.$store.getters["pmtrack/tmp_series"];
                data = tmp[key];
                switch(this.increase_outlet) {
                case true:
                    this.$store.commit("pmtrack/setValueSeries", {index, data});    
                    break;
                case false:
                    data = [];
                    this.$store.commit("pmtrack/setValueSeries", {index, data});
                }
                break;

              case 'new_product':
                this.new_product = !this.new_product;
                checkTypeOnClick = 2;
                key = 'NP';

                index = checkTypeOnClick;
                tmp = this.$store.getters["pmtrack/tmp_series"];
                data = tmp[key];
                switch(this.new_product) {
                case true:
                    this.$store.commit("pmtrack/setValueSeries", {index, data});    
                    break;
                case false:
                    data = [];
                    this.$store.commit("pmtrack/setValueSeries", {index, data});
                }
                break;

              case 'compete':
                this.compete = !this.compete;
                checkTypeOnClick = 3;
                key = 'CP';

                index = checkTypeOnClick;
                tmp = this.$store.getters["pmtrack/tmp_series"];
                data = tmp[key];
                switch(this.compete) {
                case true:
                    this.$store.commit("pmtrack/setValueSeries", {index, data});    
                    break;
                case false:
                    data = [];
                    this.$store.commit("pmtrack/setValueSeries", {index, data});
                }
            }
        },
        onExpand(index) {
            this.indexExpand = index;
            if(this.indexExpand == this.oldExpand) {
                this.checkExpand = (this.checkExpand) ? false : true;
            } else {
                this.checkExpand = true;
            }
            this.oldExpand = index;
        },
        customLabel({
            id,
            label
        }) {
            return `${id} - ${label}`;
        },
        clearAll(id, type) {
            if (type == "product") {
                this.filterProductGroup = [];
            } else if (type == "customer") {
                this.filterCustGroup = [];
            }
        },
        countString(string) {
            if (string.id !== undefined) {
                return string.id + " - " + string.name;
            } else {
                return string.name;
            }
        },
        deleteFilter(items, index) {
            this.filterChips.splice(index, 1);
            if (items.type == "product") {
                this.filterProductGroup = [];
            } else if (items.type == "customer") {
                this.filterCustGroup = [];
            }
            this.searchPromotion();
        },
        closeFilterDialog() {
            if (this.filterChips.length == 0) {
                this.filterProductGroup = [];
                this.filterCustGroup = [];
            }
            this.showFilterDialog = false;
        },
        addCondFilter() {
            this.showFilterDialog = false;
            this.filterChips = [];
            for (let i = 0; i < 2; i++) {
                let obj = {};
                if (i == 0) {
                    if (this.filterProductGroup.id !== undefined) {
                        obj = {
                            name: this.filterProductGroup.label,
                            id: this.filterProductGroup.id,
                            type: "product"
                        };
                    }
                } else if (i == 1) {
                    if (this.filterCustGroup._id !== undefined) {
                        obj = {
                            name: this.filterCustGroup.group_name,
                            // id: this.filterCustGroup._id,
                            type: "customer"
                        };
                    }
                }

                if (obj.name !== undefined) {
                    this.filterChips.push(obj);
                }
            }
            this.searchPromotion();
        },
        searchPromotion() {
            let prodgroup = "";
            let custgroup = "";
            if (this.filterProductGroup.id !== undefined) {
                prodgroup = this.filterProductGroup.id;
            }
            if (this.filterCustGroup._id !== undefined) {
                custgroup = this.filterCustGroup._id;
            }

            this.$store.dispatch("pmtrack/searchPromotion", {
                status: this.slcStatus,
                keyword: this.iptSearch,
                custgroup: custgroup,
                prodgroup: prodgroup
            });
        },
        onChildrow(child) {
            if (child) {
                var childid = child.split(",");
                for (var x in childid) {
                    var parent = this.promotion[childid[x]]["parent"];
                    if (!this.promotion[childid[x]]["style"]) {
                        this.promotion[childid[x]]["style"] = "display: none;";
                        this.promotion[parent]["icon"] = "";
                        this.promotion[parent]["icon2"] = "display: none;";
                    } else {
                        this.promotion[childid[x]]["style"] = "";
                        this.promotion[parent]["icon"] = "display: none;";
                        this.promotion[parent]["icon2"] = "";
                    }
                }
            }
        },
        deleteCondFilter(index) {
            this.filterChips.splice(index, 1);
        },
        closeFilterDialog() {
            if (this.filterChips.length == 0) {
                this.filterProduct = [];
                this.filterCustGroup = [];
            }
            this.showFilterDialog = false;
        }
    }
};
</script>

<style lang="scss">
.mktops-promotions-track {
    padding: 20px;
    background-color: white;
    width: 100%;
    display: inline-flex;

    .head-title-page {
        width: 100%;
        font-family: Lato;
        font-size: 18px;
        color: #797979;
        font-weight: bold;
        margin: 5px;
    }

    .mktops-maincontent-track {
        height: calc(100vh - 40px);
        overflow-y: auto;

        &::-webkit-scrollbar {
            height: 7px;
            width: 8px;
            background: #F7F7F7;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #F7F7F7;
            border-radius: 5px;
        }

        .main-content-header {
            display: block;
            padding: 15px 30px 0 30px;
            // padding: 24px 30px;

            .mktops-mainheader-text {
                flex: none;
                width: 100%;
            }

            .mktops-subheader-text {
                font-family: roboto;
                font-size: 16px;
                font-weight: bold;
                text-transform: uppercase;
            }

            .group-mktops-label {
                display: inline-block;
                width: 25%;
            }

            .group-mktops-label-btn {
                display: inline-block;
                width: 75%;

                &.text-align {
                    text-align: right;
                    width: 75%;
                }

                .mktops-search-text-align {
                    display: inline-block;
                    width: 73%;
                }

                .mktops-select-text-align {
                    display: inline-block;
                    width: 27%;
                    text-align: right;
                }

                .mktops-label-btn {
                    display: inline-block;
                    margin-right: 1em;
                    padding: 3px 11px;
                    line-height: 2em;
                    border-radius: 4px;
                    color: white;
                    font-size: 10px;
                    font-weight: bold;
                    font-family: roboto;
                    cursor: pointer;

                    &.green {
                        background-color: #52b6b0;
                    }

                    &.blue {
                        background-color: #527de5;
                    }

                    &.sky {
                        background-color: #5daaec;
                    }

                    &.violet {
                        background-color: #9a67e3;
                    }

                    &.gray {
                        background-color: #efefef;
                        color: #414141;
                    }
                }

                .mktops-select-view {
                    display: inline-block;
                    vertical-align: middle;

                    .md-field.box>.md-input.md-select-value,
                    .md-field.box>.md-menu.md-select {
                        height: 28px;
                        width: 200px;
                    }

                    .md-field.md-field.box {
                        padding: 10px 11px;
                        margin: 4px 0 0;
                        padding: 10px 11px;
                        margin: 4px 0 0;

                        &.dp-performance {
                            padding-left: 25px !important;
                            padding-top: 8px !important;
                        }
                    }

                    .md-field:after,
                    .md-field:before {
                        left: unset;
                    }

                    .md-field.box .md-input.md-input.md-select-value,
                    .md-field.box label {
                        font-size: 12px;
                        padding-left: 12px;
                    }

                    .md-field.box>.md-menu.md-select {
                        overflow: hidden;
                        width: 131px;
                    }

                    .md-field.box .md-select {
                        background-color: #efefef;
                        border-radius: 3px;
                    }

                    .md-search-box {
                        margin: 16px 20px 15px 15px;
                        padding-top: unset;
                        border-radius: 3px;
                        min-height: 20px;
                        width: 336px;
                        box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0), 0 1px 1px -2px rgba(0, 0, 0, 0);

                        .md-icon.material-icons {
                            margin-left: 17px;
                            color: rgba(0, 0, 0, 0.54);
                            font-size: 14px;
                        }

                        .md-input::-webkit-input-placeholder {
                            font-size: 14px;
                        }

                        &.md-field>.md-icon:after,
                        &.md-field:after,
                        &.md-field:before {
                            content: none;
                        }
                    }
                }
            }
        }

        .mktops-graph-layout {
            padding: 15px 20px;
            flex: none;
            width: 100%;

            .md-card {
                box-shadow: 0 0 3px rgba(0, 0, 0, 0.16);
            }

            .echarts {
                background-color: #F8F8F8;
                width: 100%;
                padding-top: 20px;
                padding-bottom: 10px;
                margin-top: 15px;

                .graph-tooltips-head {
                    margin: 0 0 0.5em;
                    color: #414141;
                    font-weight: bold;
                }

                .graph-tooltips-label {
                    margin: 0;
                    color: #5464BD;
                }

                .graph-tooltips-text {
                    margin: 0;
                    color: #414141;
                }
            }
        }

        .mktops-list-layout {
            // margin-top: 15px;
            padding-right: 10px;
            margin-bottom: 2px;

            .filter-chips {
                padding: 0 30px;
                margin-bottom: 10px;

                .md-chip {
                    margin-bottom: 5px;
                }

                .md-chip.md-theme-default {
                    background-color: #3F51B5;
                    color: #FFFFFF;
                }
            }

            .mktops-circle-green {
                width: 36px;
                height: 36px;
                background-color: #52b6b0;
                border-radius: 40px;
                line-height: 36px;
                text-align: center;
            }

            .md-card {
                box-shadow: 0 0 3px rgba(0, 0, 0, 0.16);
                // box-shadow: 0 0 0 0 rgba(0, 0, 0, .2), 0 0 0 0 rgba(0, 0, 0, .14), 0 0 0 0 rgba(0, 0, 0, .12);
                width: 100%;

                .md-card.md-table-list {
                    box-shadow: unset;

                    .md-scrollbar::-webkit-scrollbar {
                        background-color: white !important;
                    }

                    .md-scrollbar::-webkit-scrollbar-thumb {
                        background-color: rgba(0, 0, 0, 0.11);
                        border-radius: 5px;
                    }
                }
            }

            .md-table-fixed-header {
                height: 40px;

                .md-table-head-container {
                    padding: unset;
                }

            }

            .md-table-list {
                padding-right: 8px;
                font-size: 12px;
                font-family: Roboto;
                height: 400px;

                tbody td {
                    border-top: 0;
                }

                .md-table-head {
                    color: #414141;
                }

                .md-table-head-label {
                    padding: 6px 0;
                }

                .md-table-cell-container {
                    padding: 6px 0;
                }

                .mktops-button {
                    width: 30px;

                    .md-table-cell-container {
                        padding: 6px 0 6px 40px;
                    }
                }

                .mktops-button2 {
                    width: 50px;

                    .md-table-cell-container {
                        padding: 6px 30px 6px 0;
                    }
                }

                .mktops-circle {
                    // width: 30px;

                    .md-table-cell-container {
                        padding: unset;
                    }
                }

                .mktops-promo-list-name {
                    .title-list {
                        color: rgba(0, 0, 0, 0.38);
                    }

                    .subtitle-list {
                        color: rgba(0, 0, 0, 0.7);
                        line-height: 12px;
                        color: #414141;
                        font-weight: 400;
                    }
                }
            }
        }
    }

    .mktops-maincontent-track:hover {
        &::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.12);
        }
    }

    .filter-chips {
        margin-top: 5px;
        margin-bottom: 20px;

        .tab-chip {
            padding-left: 10px;
            padding-right: 8px;
            border-radius: 35px;
            color: white;
            font-size: 12px;
            padding-top: 5px;
            padding-bottom: 5px;

            &.-primary {
                // background-color: #3F51B5;
                background-color: #3f7fb5;
                margin-right: 5px;
            }

            &.-delete {
                // background-color: #11258c;
                background-color: #1c64a0;
                padding-left: 4px;
                padding-right: 4px;
                padding-top: 2px;
                padding-bottom: 2px;
                margin-left: 3px;
                cursor: pointer;

                .material-icons {
                    font-size: 11px;
                }
            }
        }
    }

    #table-track-list {
        width: 100%;
        margin-left: 10px;
        margin-right: 10px;


        #divHeadList {
            width: 99.3%;
            display: -webkit-inline-box;
            font-size: 13px;
            font-weight: bold;
            margin-top: 15px;
            margin-bottom: 15px;

            div {
                // border: 1px solid pink;
                padding-left: 5px;
                padding-right: 5px;

                &.-text-right {
                    text-align: right;
                }

                &.-text-center {
                    text-align: center;
                }
            }
        }

        #divBodyList {
            height: calc(100vmin - 450px);
            width: 100%;
            display: block;
            overflow-y: scroll;
            font-size: 13px;
            margin-bottom: 15px;

            >div {
                width: 100%;
                // display: -webkit-inline-box;
                display: inline-block;
                // padding-top: 6px;
                // padding-bottom: 6px;

                #mainRows {
                    width: 100%;
                    padding-top: 4px;
                    padding-bottom: 4px;
                    padding-left: 0px;
                    padding-right: 0px;
                    display: table;
                }

                .childRows {
                    width: 100%;
                    padding-left: 0px;
                    padding-right: 0px;
                    padding-top: 4px;
                    padding-bottom: 4px;
                    // display: flex;
                    display: none;
                }

                div {
                    // border: 1px solid pink;
                    padding-left: 5px;
                    padding-right: 5px;
                    display: table-cell;
                    vertical-align: middle;

                    &.-text-right {
                        text-align: right;
                    }

                    &.-text-center {
                        text-align: center;
                    }

                    &.nowrap-title {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .subdiv {
                        padding-right: 0px;
                        padding-left: 0px;

                        .-percent {
                            opacity: 0.5;
                            padding-top: 5px;
                        }

                        .-bgred {
                            padding-left: 6px;
                            padding-right: 6px;
                            border-radius: 35px;
                            background-color: #f44336;
                            color: white;
                        }
                    }
                    
                    .expand-row {
                        cursor: pointer;
                        opacity: 0.54;
                    }
                }
            }

            &::-webkit-scrollbar {
                height: 7px;
                width: 8px;
            }

            .row-bg-gray:hover {
                background: rgba(236, 236, 235, 1);
            }
        }
    }
}
</style>
